<template>
  <section class="instagram-section">
    <HeadingSlim class="mb-10">Latest from Instagram</HeadingSlim>
    <div
      class="flex flex-col md:grid md:grid-cols-2 lg:flex lg:flex-row flex-wrap gap-4"
    >
      <img
        v-for="img in instagramPosts"
        class="rounded-lg lg:max-w-[290px] object-contain"
        :src="img.media_storage_url"
        :alt="
          img.caption ?? 'An image posted to the 64 Analytics Instagram account'
        "
        loading="lazy"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { Tables } from '~/types/database.types';

defineProps<{
  instagramPosts: Tables<'instagram_media'>[];
}>();
</script>
